export interface UserRequestModel {
  name: string;
  email: string;
  role: string;
  codes: string[];
}
